import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Grid, Modal, Select, TextField, Typography } from '@iho-design-system/Loader';
import editSVG from '../../../assets/images/icons/edit.svg';
import post from '../../../api/post';

const initialParams = {
    accountName: { value: '', color: 'dark' },
    cardNumber: { value: '', color: 'dark' },
    bankName: { value: '', color: 'dark' },
    bankAccount: { value: '', color: 'dark' },
    sheba: { value: '', color: 'dark' }
};

const bankNameList = [
    '',
    'بانک ملّی ایران',
    'بانک اقتصاد نوین',
    'بانک قرض‌الحسنه مهر ایران',
    'بانک سپه',
    'بانک پارسیان',
    'بانک قرض‌الحسنه رسالت',
    'بانک صنعت و معدن',
    'بانک کارآفرین',
    'بانک کشاورزی',
    'بانک سامان',
    'بانک مسکن',
    'بانک سینا',
    'بانک توسعه صادرات ایران',
    'بانک خاورمیانه',
    'بانک توسعه تعاون',
    'بانک شهر',
    'پست بانک ایران',
    'بانک دی',
    'بانک صادرات',
    'بانک ملت',
    'بانک تجارت',
    'بانک رفاه',
    'بانک حکمت ایرانیان',
    'بانک گردشگری',
    'بانک ایران زمین',
    'بانک قوامین',
    'بانک انصار',
    'بانک سرمایه',
    'بانک پاسارگاد'
];

const Toolbar = ({ props, alertProps, reloadFinanceProps }) => {
    const [bankAccount, setBankAccount] = useState([]);
    const [params, setParams] = useState(initialParams);

    useEffect(() => {
        if (props.bankAccount.status === 200) {
            setBankAccount(props.bankAccount.data);
        }
    }, [props]);

    const updateField = (key, value, valid) => {
        setParams(prev => ({
            ...prev,
            [key]: {
                value,
                color: valid ? 'dark' : 'danger'
            }
        }));
    };

    const addBankAccountHandler = (key, value) => {
        switch (key) {
            case 'accountName':
            case 'bankName':
            case 'bankAccount':
                updateField(key, value, value !== '');
                break;
            case 'cardNumber':
                updateField(key, value, value !== '' && value.length === 16);
                break;
            case 'sheba':
                updateField(key, value, value !== '' && value.length === 24);
                break;
            default:
                break;
        }
    };

    const addBankAccount = async () => {
        let isValid = true;

        Object.keys(params).forEach(key => {
            const value = params[key].value;
            const valid =
                key === 'cardNumber' ? value && value.length === 16 :
                key === 'sheba' ? value && value.length === 24 :
                value !== '';

            if (!valid) {
                isValid = false;
                updateField(key, value, false);
            }
        });

        if (!isValid) return;

        const body = {
            AccountName: params.accountName.value,
            CardNumber: params.cardNumber.value,
            BankName: params.bankName.value,
            bankAccount: params.bankAccount.value,
            Sheba: params.sheba.value
        };

        const result = await post({
            ctrl: 'Bankaccount',
            method: 'Add',
            query: '',
            body
        });

        if (result.status === 200) {
            alertProps(['success', 'با موفقیت انجام شد ']);
            reloadFinanceProps(Math.floor(Math.random() * 100));
        } else {
            alertProps(['danger', result.data.Message]);
        }

        closeModal('addBankAccountModal');
        setParams(initialParams);
    };

    const openModal = modal => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
    };

    const closeModal = modal => {
        document.querySelector(`.${modal}`).classList.add('d-none');
    };

    return (
        <>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item size='col-12 md-8'>
                        <Typography component='h4' ms={{ fontWeight: 'normal !important' }}>
                            لیست شماره حساب‌ها
                        </Typography>
                        <Typography component='p' className='d-block' ms={{ color: '#6F6F7E' }}>
                            کارت‌های خود را، برای استفاده راحت تر در لیست اضافه کنید.
                        </Typography>
                    </Grid.Item>
                    <Grid.Item size='col-12 md-4' className='text-left'>
                        <Button
                            onClick={bankAccount.length <= 9 ? () => openModal('addBankAccountModal') : undefined}
                            variant='filled'
                            color={bankAccount.length <= 9 ? 'primary' : 'danger'}
                            ms={{ '@media(max-width:576px)': { width: '100% !important' } }}>
                            افزودن حساب
                        </Button>
                    </Grid.Item>
                    {bankAccount.length > 9 && (
                        <Grid.Item size='col-12'>
                            <Alert className='w-100 position-static' color='danger' ms={{ boxShadow: 'none !important' }}>
                                کاربر گرامی، شما مجاز به ثبت حداکثر 10 حساب بانکی می باشید.
                            </Alert>
                        </Grid.Item>
                    )}
                </Grid.Wrapper>
            </Grid>

            <Modal className='addBankAccountModal'>
                <Modal.Wrapper size='xs' ms={{ '@media(max-width:576px)': { width: 'calc(100% - 12px) !important' } }}>
                    <Modal.Header className='my-md mt-0 border-solid-bottom border-light'>
                        افزودن حساب
                        <Box />
                    </Modal.Header>
                    <Typography className='px-lg'>
                        اطلاعات حساب بانکی خود را وارد نمایید.
                    </Typography>
                    <Box component='form' className='p-sm'>
                        <Grid>
                            <Grid.Wrapper>
                                <Grid.Item size='col-12'>
                                    <TextField
                                        label='نام صاحب حساب'
                                        icon={editSVG}
                                        value={params.accountName.value}
                                        color={params.accountName.color}
                                        onChange={e => addBankAccountHandler('accountName', e)}
                                    />
                                </Grid.Item>
                                <Grid.Item size='col-12 md-6'>
                                    <TextField
                                        label='شماره کارت'
                                        icon={editSVG}
                                        value={params.cardNumber.value}
                                        color={params.cardNumber.color}
                                        onChange={e => addBankAccountHandler('cardNumber', e)}
                                    />
                                </Grid.Item>
                                <Grid.Item size='col-12 md-6'>
                                    <Select
                                        label='نام بانک'
                                        search
                                        init={bankNameList[0]}
                                        color={params.bankName.color}
                                        onChange={e => addBankAccountHandler('bankName', e)}>
                                        {bankNameList.filter(Boolean).map((item, i) => (
                                            <Select.Item key={i} value={item}>
                                                {item}
                                            </Select.Item>
                                        ))}
                                    </Select>
                                </Grid.Item>
                                <Grid.Item size='col-12 md-6'>
                                    <TextField
                                        label='شماره حساب'
                                        icon={editSVG}
                                        value={params.bankAccount.value}
                                        color={params.bankAccount.color}
                                        onChange={e => addBankAccountHandler('bankAccount', e)}
                                    />
                                </Grid.Item>
                                <Grid.Item size='col-12 md-6'>
                                    <TextField
                                        label='شماره شبا'
                                        icon={editSVG}
                                        value={params.sheba.value}
                                        color={params.sheba.color}
                                        onChange={e => addBankAccountHandler('sheba', e)}
                                    />
                                </Grid.Item>
                                <Grid.Item size='col-12 md-6' className='d-flex'>
                                    <Button onClick={addBankAccount} variant='filled' color='primary' className='w-25'>
                                        تایید
                                    </Button>
                                    <Box className='mx-sm' />
                                    <Button
                                        onClick={() => closeModal('addBankAccountModal')}
                                        variant='outlined'
                                        color='danger'
                                        className='w-25'>
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid.Wrapper>
                        </Grid>
                    </Box>
                </Modal.Wrapper>
            </Modal>
        </>
    );
};

export default Toolbar;
